<template>
    <div>
        <div class="md-layout md-alignment-center-left">
            <div class="md-layout-item md-size-40" id="code_enable">
                当前视频APP{{vCodeEnable?'可以使用':'已经锁定'}}
            </div>
            <div class="md-layout-item md-size-10" id="upload1">
                <md-button class="md-icon-button" @click="changeVCodeEnable">
                    <md-icon>{{!vCodeEnable?'lock':'lock_open'}}</md-icon>
                </md-button>
            </div>
        </div>

        <div class="md-layout md-alignment-center-left">
            <div class="md-layout-item md-size-40" id="code_summary">
                共导入视频码{{totalCount}}个，现已经激活{{ parseInt(totalCount)-parseInt(noUsedCount) }}个，尚未激活{{ noUsedCount }}个
            </div>
            <div class="md-layout-item md-size-10" id="upload">
                <md-button class="md-raised md-primary" @click="showUploadDialog">上传视频码</md-button>
            </div>
        </div>

        <md-dialog :md-active.sync="codeUploadDialog">
            <md-dialog-title>视频码上传</md-dialog-title>
            <div class="md-layout">
                <md-field>
                    <label>请选择视频码文件</label>
                    <md-file accept="text/plain" name="vcode" @change="inputFileChange"/>
                </md-field>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" @click="codeUploadDialog = false">取消</md-button>
                <md-button class="md-primary" @click="uploadCode">上传</md-button>
            </md-dialog-actions>
        </md-dialog>

        <div class="md-layout md-alignment-center-left" v-if="vCodeEnable">
            <div class="md-layout-item md-size-40">
                <md-field>
                    <label>APK下载地址</label>
                    <md-input v-model="apkDownloadUrl" placeholder="输入下载地址"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item md-size-10" id="url_modify">
                <md-button class="md-raised md-primary" @click="modifyDownloadUrl()">
                    修改地址
                </md-button>
            </div>
        </div>

        <RewardManager/>

        <md-dialog :md-active.sync="loading" :md-close-on-esc=false :md-click-outside-to-close=false>
            <div class="md-layout md-alignment-center-center" id="loading_content">
                <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            </div>
        </md-dialog>

        <md-dialog :md-active.sync="showResultDialog">
            <md-dialog-title>如下视频码重复</md-dialog-title>
            <div>{{importResult}}</div>
        </md-dialog>
        <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
    </div>
</template>

<script>
    import RewardManager from "@/components/vcode/RewardManager";
    export default {
        name: "VCodeManager",
        components: {RewardManager},
        data: () => ({
            noUsedCount: 0,
            totalCount: 0,
            apkDownloadUrl: '',
            codeUploadDialog: false,
            codeImportFile: null,
            loading: false,
            showResultDialog: false,
            importResult: null,
            vCodeEnable: false,
            toast: false,
            toastMsg: "",
        }),
        mounted() {
            this.getVCodeStatus();
            this.getVCode();
        },
        methods: {
            getVCodeStatus: function () {
                this.$http.get('/api/app/vcode/status/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.noUsedCount = data.data.no_used_count;
                                this.totalCount = data.data.total_count;
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    if (error.response.status === 403) {
                        localStorage.clear();
                        this.$router.replace('/login')
                    } else {
                        this.showErrorTips('未知错误' + error);
                    }
                })
            },
            getVCode: function () {
                this.$http.get('/api/app/order/vcode/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.apkDownloadUrl = data.data.url;
                                this.vCodeEnable = true;
                            } else {
                                switch (data.code) {
                                    case 10200:
                                        this.vCodeEnable = false;
                                        break
                                    default:
                                        this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    if (error.response.status === 403) {
                        localStorage.clear();
                        this.$router.replace('/login')
                    } else {
                        this.showErrorTips('未知错误' + error);
                    }
                })
            },
            modifyDownloadUrl: function () {
                this.$http.post('/api/app/vcode/url/', {
                    url: this.apkDownloadUrl
                }).then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.getVCode();
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    if (error.response.status === 403) {
                        localStorage.clear();
                        this.$router.replace('/login')
                    } else {
                        this.showErrorTips('未知错误' + error);
                    }
                })
            },
            showUploadDialog: function () {
                this.codeUploadDialog = true;
            },
            inputFileChange(e) {
                this.codeImportFile = e.target.files[0]
            },
            uploadCode: function () {
                this.codeUploadDialog = false;
                this.loading = true;
                let postData = new FormData();
                postData.append('vcodes', this.codeImportFile);
                this.importResult = null;
                this.$http.post('/api/app/vcode/batch/', postData)
                    .then(response => {
                        this.loading = false;
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.getVCodeStatus();
                                if (data.data.codes.length !== 0) {
                                    this.showResultDialog = true
                                    this.importResult = data.data.codes.toString();
                                } else {
                                    this.showTips('上传成功');
                                }
                            } else {
                                switch (data.code) {
                                    default:
                                        this.showErrorTips('上传失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.showErrorTips('未知错误' + error);
                    });
            },
            changeVCodeEnable: function () {
                this.$http.put('/api/app/vcode/enable/' + !this.vCodeEnable + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.getVCode();
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    if (error.response.status === 403) {
                        localStorage.clear();
                        this.$router.replace('/login')
                    } else {
                        this.showErrorTips('未知错误' + error);
                    }
                })
            },
            showTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            showErrorTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
        }
    }
</script>

<style scoped>
    #code_enable {
        text-align: left;
    }

    #loading_content {
        padding: 50px 0;
    }

    .md-layout-item {
        padding: 0 10px;
    }

    #code_summary {
        text-align: left;
    }

    #url_modify {
        text-align: left;
    }

    #upload {
        text-align: left;
    }
</style>